import React from 'react';
import WalkThroughTable from '../../components/WalkThroughTable';

const SuiteWalkThroughs = (props: any) => {
  const { suite, property, propertyManagerDetails, refreshSuiteCounts } = props;

  return (
    <WalkThroughTable
      suite={suite}
      property={property}
      propertyManagerDetails={propertyManagerDetails}
      refreshSuiteCounts={refreshSuiteCounts}
    />
  );
};

export default SuiteWalkThroughs;
